import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { access_token } from "./utils/constant";
import PrivateRoutes from "./utils/private-routes";
import * as AuthActions from './redux/actions/authAction';

//! Component
import DescriptionModal from "./components/modal/DescriptionModal";

//! Component
import RouteHeader from "./components/common/RouteHeader";

//! Auth 
import Login from './pages/login';
import ForgetPassword from './pages/auth/forget-password';
import PartnerForgetPassword from './pages/auth/partner-forget-password';
import ResetPassword from './pages/auth/reset-password';
import PartnerLogin from "./pages/login/partner";

//! Dahboard
import Overview from "./pages/dashboard";
import Profile from "./pages/dashboard/profile";

//! Management
import Admins from "./pages/management/admins";
import AdminPartner from "./pages/management/admins/partners";
import AdminPartnerAffiliates from "./pages/management/admins/partners/affiliates";
import AdminAffiliateCustomers from "./pages/management/admins/partners/affiliates/customers";
import PartnerAffiliatesList from "./pages/management/partners/affiliates";
import AddAdmin from "./pages/management/admins/add-admin";
import RegistrationNumbers from "./pages/management/registration-numbers";
import Partners from "./pages/management/partners";
import PartnerCustomer from "./pages/management/partners/customers";
import AddPartner from "./pages/management/partners/add-partner";
import Customers from "./pages/management/customers";
import AdminWalletReport from "./pages/management/wallet-report/admin-wallet-report";
import PartnerWalletReport from "./pages/management/wallet-report/partner-wallet-report";
import CustomerWalletReport from "./pages/management/wallet-report/customer-wallet-report";
import DiscountCoupons from "./pages/management/discount-coupons";
import PartnerBankDetails from "./pages/management/partner-bank-details";

//! Content
import Reports from "./pages/content/reports";
import GeneratedReport from "./pages/content/reports/generated-report";
import Blogs from "./pages/content/blogs";
import AddBlogs from "./pages/content/blogs/add-blogs";
import TutorialVideos from "./pages/content/tutorial-videos";
import BusinessVideos from "./pages/content/business-videos";
import SiteSettings from "./pages/content/site-settings";
import Awards from "./pages/content/awards";
import MediaCoverage from "./pages/content/media-coverage";
import TestimonialVideos from "./pages/content/testimonial-videos";

//! Settings
import AboutUs from "./pages/settings/about-us";
import TermsofUse from "./pages/settings/terms-of-use";
import PrivacyPolicy from "./pages/settings/privacy-policy";
import RefundPolicy from "./pages/settings/refund-policy";
import ShippingPolicy from "./pages/settings/shipping-policy";
import ChangePassword from "./pages/settings/change-password";
import NotFoundPage from "./components/features/NotFoundPage";

//! Bug Tracker
import BugDashboard from "./pages/bug-tracker/dashboard";
import BugIssues from "./pages/bug-tracker/issues";
import BugReportForm from "./pages/bug-tracker/report";
import BugDetail from "./pages/bug-tracker/issues/bug-detail";

//! Revenue
import RevenueDistribution from "./pages/revenue/distribution";
import RevenueSettingsPage from "./pages/revenue/settings";
import Payouts from "./pages/revenue/payouts";


const App = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // TODO: Remove Focus On Wheel Rotation - Input type:number
  useEffect(() => {
    //   const handleWheel = (e) => {
    //     if (document.activeElement.type === 'number') {
    //       e.target.blur();
    //     }
    //   };
    const handleWheel = (e) => {
      if (document.activeElement.type === 'number') {
        e.preventDefault(); // Stop scroll action
        document.activeElement.blur(); // Blur the input
      }
    };

    window.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);

  useEffect(() => {
    //! Dispatching API For Getting Admin Details
    const token = localStorage.getItem(access_token);
    token && dispatch(AuthActions.getSuperadminAdminPartnerDetails());
  }, [dispatch, navigate]);

  return (
    <>
      <Routes>
        <Route path='/auth/login' element={<Login />} />
        <Route path='/auth/login/partner' element={<PartnerLogin />} />
        <Route path='/auth/forget-password' element={<ForgetPassword />} />
        <Route path='/auth/partner-forget-password' element={<PartnerForgetPassword />} />
        <Route path='/auth/reset-password' element={<ResetPassword />} />

        <Route path="/" exact element={<PrivateRoutes />}>
          <Route path="*" element={<NotFoundPage />} />
          {/* Dashboard */}
          <Route index element={<Overview />} />
          <Route path="/dashboard/my-profile" element={<Profile />} />

          {/* Management */}
          <Route path="/management/admins" element={<Admins />} />
          <Route path="/management/admins/partner" element={<AdminPartner />} />
          <Route path="/management/admins/partner/affiliates" element={<AdminPartnerAffiliates />} />
          <Route path="/management/admins/partner/affiliates/customers" element={<AdminAffiliateCustomers />} />
          <Route path="/management/admins/add-admin" element={<AddAdmin mode={'Add'} />} />
          <Route path="/management/admins/edit-admin" element={<AddAdmin mode={'Edit'} />} />
          <Route path="/management/registration-numbers" element={<RegistrationNumbers />} />

          <Route path="/management/partners" element={<Partners label={'Partner'} />} />
          <Route path="/management/partners/affiliates" element={<PartnerAffiliatesList />} />
          <Route path="/management/partners/customer" element={<PartnerCustomer label={'Partner'} />} />
          <Route path="/management/partners/add-partner" element={<AddPartner mode={'Add'} label={'Partner'} />} />
          <Route path="/management/partners/edit-partner" element={<AddPartner mode={'Edit'} label={'Partner'} />} />

          <Route path="/management/affiliates" element={<Partners label={'Affiliate'} />} />
          <Route path="/management/affiliates/customer" element={<PartnerCustomer label={'Affiliate'} />} />
          <Route path="/management/affiliates/add-affiliate" element={<AddPartner mode={'Add'} label={'Affiliate'} />} />
          <Route path="/management/affiliates/edit-affiliate" element={<AddPartner mode={'Edit'} label={'Affiliate'} />} />

          <Route path="/management/customers" element={<Customers />} />
          {/* <Route path="/management/admin-wallet-report" element={<AdminWalletReport />} />
          <Route path="/management/partner-wallet-report" element={<PartnerWalletReport />} />
          <Route path="/management/customer-wallet-report" element={<CustomerWalletReport />} /> */}
          <Route path="/management/discount-coupons" element={<DiscountCoupons />} />
          <Route path="/management/partner-bank-details" element={<PartnerBankDetails />} />

          {/* Content */}
          <Route path="/content/report-editor" element={<Reports />} />
          <Route path="/content/generated-report" element={<GeneratedReport />} />
          <Route path="/content/blogs" element={<Blogs />} />
          <Route path="/content/blogs/add-blogs" element={<AddBlogs mode={'Add'} />} />
          <Route path="/content/blogs/edit-blogs" element={<AddBlogs mode={'Edit'} />} />

          <Route path="/content/business-videos" element={<BusinessVideos />} />
          <Route path="/content/tutorial-videos" element={<TutorialVideos />} />
          <Route path="/content/testimonial-videos" element={<TestimonialVideos />} />
          <Route path="/content/site-settings" element={<SiteSettings />} />
          <Route path="/content/awards" element={<Awards />} />
          <Route path="/content/media-coverage" element={<MediaCoverage />} />

          {/* Settings */}
          <Route path="/settings/change-password" element={<ChangePassword />} />
          {/* <Route path="/settings/about-us" element={<AboutUs />} /> */}
          <Route path="/settings/terms-of-use" element={<TermsofUse />} />
          <Route path="/settings/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/settings/refund-policy" element={<RefundPolicy />} />
          <Route path="/settings/shipping-policy" element={<ShippingPolicy />} />

          {/* Bug Tracker */}
          <Route path="/bug-tracker/dashboard" element={<BugDashboard />} />
          <Route path="/bug-tracker/issues" element={<BugIssues />} />
          <Route path="/bug-tracker/report" element={<BugReportForm />} />
          <Route path="/bug-tracker/issues/:bugId" element={<BugDetail />} />

          {/* Revenue */}
          <Route path="/revenue/distribution" element={<RevenueDistribution />} />
          <Route path="/revenue/settings" element={<RevenueSettingsPage />} />
          <Route path="/revenue/payouts" element={<Payouts />} />
        </Route>
      </Routes>

      <DescriptionModal />
    </>
  );
}

export default App;